import { fonts } from '@/config.fonts';
import type { IFont } from '@/typescript/interfaces/IFont';

export async function loadFonts(): Promise<IFont[]> {
    const fontPromises = fonts.map((font): Promise<IFont> => {
        const parsedName = font.name.split('.')[0];
        const fontFace = new FontFace(parsedName, `url(${new URL(encodeURI(font.path), document.baseURI).href})`);

        const fontLoadPromise = fontFace.load();
        fontLoadPromise
            .then(() => {
                document.fonts.add(fontFace);
            })
            .catch((error) => {
                console.error(`Font ${parsedName} failed to load`, error);
            });

        return fontLoadPromise.then(() => ({ fontFace, preview: font.preview }));
    });

    const fontFaces = await Promise.all(fontPromises);

    return fontFaces.filter((font) => font.fontFace.family);
}
